import { put } from "redux-saga/effects";
import { message } from "antd";
import { ApiCaller } from "../../config";
import { OthersAction } from "../actions";

import { DefaultNotification } from "../../components";

export default class OthersMiddleware {
  static *getCountries({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-countries");
      if (res.status === 200) {
        yield put(OthersAction.getCountriesSuccess(res.data.data));
      } else {
        yield put(OthersAction.getCountriesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getCountriesFailure());
    }
  }
  static *addCountry({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post("/other/add-country", payload);
      if (res.status === 200) {
        yield put(OthersAction.addCountrySuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(OthersAction.addCountryFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.addCountryFailure());
    }
  }
  static *editCountry({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put("/other/edit-country", payload);
      if (res.status === 200) {
        yield put(OthersAction.editCountrySuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(OthersAction.editCountryFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.editCountryFailure());
    }
  }
  static *getContinents({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-continents");
      if (res.status === 200) {
        yield put(OthersAction.getContinentsSuccess(res.data.data));
      } else {
        yield put(OthersAction.getContinentsFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getContinentsFailure());
    }
  }
  static *getRegions({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-regions");
      if (res.status === 200) {
        yield put(OthersAction.getRegionsSuccess(res.data.data));
      } else {
        yield put(OthersAction.getRegionsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getRegionsFailure());
    }
  }
  static *getPopularSubs({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/other/get-popular-subjects`);
      if (res.status === 200) {
        yield put(OthersAction.getPopularSubsSuccess(res.data.data));
      } else {
        yield put(OthersAction.getPopularSubsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getPopularSubsFailure());
    }
  }

  static *getTags({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/other/get-tags`);
      if (res.status === 200) {
        yield put(OthersAction.getTagsSuccess(res.data.data));
      } else {
        yield put(OthersAction.getTagsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getTagsFailure());
    }
  }

  static *getPaymentPlans({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/other/get-payment-plans`);
      if (res.status === 200) {
        yield put(OthersAction.getPaymentPlansSuccess(res.data.data));
      } else {
        yield put(OthersAction.getPaymentPlansFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getPaymentPlansFailure());
    }
  }
  static *getPrograms({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/other/get-programs?programTypes=${payload.programTypes}`
      );
      if (res.status === 200) {
        yield put(OthersAction.getProgramsSuccess(res.data.data));
      } else {
        yield put(OthersAction.getProgramsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getProgramsFailure());
    }
  }

  static *getOnlineUsers({ payload, cb }) {
    try {
      yield put(OthersAction.getOnlineUsersSuccess(payload));
      if (cb) {
        cb();
      }
    } catch (err) {
      yield put(OthersAction.getOnlineUsersFailure());
    }
  }
  static *getProgramTypes({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-program-types");
      if (res.status === 200) {
        yield put(OthersAction.getProgramTypesSuccess(res.data.data));
      } else {
        yield put(OthersAction.getProgramTypesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getProgramTypesFailure());
    }
  }
  static *getVisaInfo({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-visa-info");
      if (res.status === 200) {
        yield put(OthersAction.getVisaInfoSuccess(res.data.data));
      } else {
        yield put(OthersAction.getVisaInfoFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getVisaInfoFailure());
    }
  }
  static *addVisaInfo({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post("/other/add-visa-info", payload);
      if (res.status === 200) {
        yield put(OthersAction.addVisaInfoSuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(OthersAction.addVisaInfoFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.addVisaInfoFailure());
    }
  }
  static *editVisaInfo({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put("/other/edit-visa-info", payload);
      if (res.status === 200) {
        yield put(OthersAction.editVisaInfoSuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(OthersAction.editVisaInfoFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.editVisaInfoFailure());
    }
  }
  static *deleteVisaInfo({ payload, cb }) {
    try {
      const res = yield ApiCaller.Delete(
        `/other/delete-visa-info?id=${payload.id}`
      );
      if (res.status === 200) {
        yield put(OthersAction.deleteVisaInfoSuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(OthersAction.deleteVisaInfoFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.deleteVisaInfoFailure());
    }
  }
  static *getDiffUniValues({ cb }) {
    try {
      const res = yield ApiCaller.Get("/other/get-diff-uni-values");
      if (res.status === 200) {
        yield put(OthersAction.getDiffUniValuesSuccess(res.data.data));
      } else {
        yield put(OthersAction.getDiffUniValuesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.getDiffUniValuesFailure());
    }
  }
  static *uploadImage({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post("/other/upload-image", payload);
      if (res.status === 200) {
        yield put(OthersAction.uploadImageSuccess(res.data.data));
      } else {
        yield put(OthersAction.uploadImageFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.uploadImageFailure());
    }
  }
  static *uploadFile({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post("/other/upload-file", payload);
      if (res.status === 200) {
        yield put(OthersAction.uploadFileSuccess(res.data.data));
      } else {
        yield put(OthersAction.uploadFileFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(OthersAction.uploadFileFailure());
    }
  }
}
